<template>

  <div class="form-check">
    <label class="form-check-label theme-card" :for="forName" :class="{ 'dark-theme': isDark }">
      <div class="theme-card-header">
        <div class="text-center">
          <LucideIcon :icon="icon" size="2x"/>
          <h3>{{ label }}</h3>
        </div>
      </div>
      <div class="theme-card-body">
        <div>
          <span class="subtitle">{{ isDark ? 'Dark' : 'Light' }}</span>
          <span class="content">
          <slot></slot>
        </span>
        </div>
        <div class="input">
          <RadioElement
              :name="forName"
                :value="label"
            :model-value="isSelected ? label : ''"
            :id="forName"
            @update:modelValue="onClick"
            />

        </div>
      </div>
    </label>
  </div>

</template>
<script lang="ts">
import { defineComponent } from 'vue';
import RadioElement from "@shared/components/elements/radio/radio.element.vue";

export default defineComponent({
  name: 'ThemeCardWidget',
  components: {RadioElement},
  emits: ['update:isSelected', 'onSelected'],
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    isDark: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    forName: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    onClick(): void {
      this.$emit('update:isSelected', true);
      this.$emit('onSelected');
    },
  },
});

</script>

<style lang="scss" scoped>

.form-check {
  margin: var(--space-0);
  padding: var(--space-0);
}

.form-check-input:checked {
  background-color: var(--accent-100);
  border-color: var(--accent-100);
}

.theme-card {
  width: 100%;
  background-color: var(--card-bg);
  box-shadow: var(--card-shadow);
  border: 1px solid var(--card-border);
  margin-bottom: var(--space-16);
  border-radius: $br-sm;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    box-shadow: var(--card-shadow-active);
  }

  & > .theme-card-header {
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100px;
    color: var(--theme-text);
    background: var(--theme-bg);


    & h3 {
      font-size: var(--fs-14);
      margin-top: var(--space-16);
      margin-bottom: var(--space-0);
      color: var(--theme-text);
    }
  }

  & > .theme-card-body {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    height: 100px;
    margin: var(--space-negative-10) var(--space-0);
    background: var(--theme-bg);

    & > div {
      width: 100%;
      margin: var(--space-0) var(--space-10);

      &.input {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 30px;
      }
    }

    & .subtitle,
    & .content {
      display: block;
    }

    & .subtitle {
      color: var(--theme-grey-text);
      font-size: var(--fs-13);
    }

    & .content {
      color: var(--theme-text);
      font-size: var(--fs-14);
    }
  }

  &.dark-theme {

    & > .theme-card-header {
      color: var(--theme-dark-text);
      background: var(--theme-dark-bg);


      & h3 {
        color: var(--theme-light-text);
      }
    }

    & > .theme-card-body {
      background: var(--theme-dark-bg);

      & .subtitle {
        color: var(--text-neutral);
      }

      & .content {
        color: var(--theme-dark-text);
      }
    }
  }
}

</style>
